var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exercises-empty"},[_c('div',{staticClass:"empty-img"}),_c('div',{staticClass:"empty-text"},[_vm._v("暂无记录")]),(_vm.isTabs)?_c('div',{staticClass:"empty-text"},[_vm._v("快来占领练习区的沙发吧!")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }